<template>
  <!-- chat -->
  <div class="chat-messages">
    <div class="SC-detail-box disable-click" v-if="MsgConnectionFailed"></div>
    <div class="super-chat-message" @click="closeSCDetail">
      <div class="SCMessages-bar-renderer" v-if="SCMessages.length > 0">
        <swiper :slidesPerView="'auto'" :pagination="{ clickable: true }" :space-between="10" class="swiper-container" ref="swiper">
          <swiper-slide
            v-for="(SCMessage, index) in SCMessages.slice(0, 20)"
            :key="index"
            @click="selectSCMessage(SCMessage, $event)"
            :class="['SCMessage-short', 'SC-bar-bg', `background-${SCMessage.sc}`, { 'SCMessage-short-disable': MsgConnectionFailed }]"
          >
            <img :src="getImageUrl(SCMessage.uid)" @error="hideImage" alt="" class="user-img" />
            <p class="user-name">{{ SCMessage.nick || 'Unknown' }}</p>
          </swiper-slide>
        </swiper>
      </div>
    </div>

    <div class="message-area">
      <Loading v-show="loading" :fullscreen="false"></Loading>
      <div class="SC-detail-box connection-failed" v-if="MsgConnectionFailed">
        <p>{{ $t('streamingVideo.key016') }}</p>
      </div>
      <div class="SC-detail-box" v-if="selectedSCMessage != null" @click="closeSCDetail">
        <div class="SC-message-details" @click.stop>
          <i class="bi bi-x leave-icon" @click="closeSCDetail"></i>
          <div :class="['superChat-massage', 'SC-bar-bg', `background-${selectedSCMessage.sc}`]">
            <div class="SC-message-user-info">
              <img :src="getImageUrl(selectedSCMessage.uid)" @error="hideImage" alt="" class="SC-message-img" />
              <div class="user-info">
                <p class="name">{{ selectedSCMessage.nick || 'Unknown' }}</p>
                <p class="price">NT$ {{ selectedSCMessage.price }}</p>
              </div>
            </div>
            <div class="SC-message-msg-info">
              <p>
                <span v-for="(block, i) in selectedSCMessage.msg" :key="i">
                  <template v-if="block.type === 'text'">
                    {{ block.content }}
                  </template>
                  <template v-else-if="block.type === 'emoji'">
                    <img :src="block.src" :alt="block.alt" :class="{ singleSticker: block.isSingleSticker }" />
                  </template>
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="message-box" ref="chatMessages" @scroll="handleScroll">
        <div v-for="(message, index) in chatMessages" :key="index" :class="['message', { 'my-message': message.uid === myUid }]">
          <div :class="['superChat-massage', 'SC-bar-bg', `background-${message.sc}`]" v-if="message.sc !== ''">
            <div class="SC-message-user-info">
              <img :src="getImageUrl(message.uid)" @error="hideImage" alt="" class="SC-message-img" />
              <div class="user-info">
                <p class="name">{{ message.nick || 'Unknown' }}</p>
                <p class="price"><span>NT$ </span>{{ message.price }}</p>
              </div>
            </div>
            <div class="SC-message-msg-info">
              <p>
                <span v-for="(block, i) in message.msg" :key="i">
                  <template v-if="block.type === 'text'">
                    {{ block.content }}
                  </template>
                  <template v-else-if="block.type === 'emoji'">
                    <img :src="block.src" :alt="block.alt" :class="{ singleSticker: block.isSingleSticker }" />
                  </template>
                </span>
              </p>
            </div>
          </div>
          <div class="default-message" v-else>
            <div class="float-left">
              <div class="user-image">
                <img :src="getImageUrl(message.uid)" @error="hideImage" alt="" />
              </div>
              <span class="user-name">{{ message.nick || 'Unknown' }}</span>
            </div>
            <div class="float-right">
              <p>
                <span v-for="(block, i) in message.msg" :key="i">
                  <template v-if="block.type === 'text'">
                    {{ block.content }}
                  </template>
                  <template v-else-if="block.type === 'emoji'">
                    <img :src="block.src" :alt="block.alt" :class="{ singleSticker: block.isSingleSticker }" />
                  </template>
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!isAtBottom && newMessageLength > 0" class="scroll-to-bottom">
        <div class="arrow-icon" @click="scrollToBottom">
          <i class="bi bi-arrow-down-short"></i>
          <!-- TODO: i18n -->
          <span>{{ newMessageLength }} messages</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, inject, watch } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { streamingGetChat, streamingGetSCMsg } from '@/api/streamingService.js';
import { useChatSocket } from '@/utils/useSocket';
import Loading from '@/components/Loading.vue';

const MAX_CHAT_MESSAGES = 400;
const MAX_FULL_MESSAGES = 400; // 回放時保留的最大訊息量
const MAX_POP_CHAT_MESSAGES = 40;
const UPDATE_MESSAGE_INTERVAL = 200;
const UPDATE_MESSAGE_BY_API_INTERVAL = 1500;

export default defineComponent({
  name: 'ChatMessage',
  components: {
    Swiper,
    SwiperSlide,
    Loading,
  },
  props: {
    cid: {
      type: String,
      required: true,
    },
    streamingInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      chatMessages: [],
      // 回放功能參數
      fullMessages: [],
      updateVODMessages: null,
      updateVODTimer: null,
      isPlayerPlayed: false,
      isVideoSeeking: false,
      canFetchNext: true,
      lastProcessedIndex: 0,
      currentLimitTs: 0,
      updateVODMessageInterval: UPDATE_MESSAGE_INTERVAL,
      loading: false,
      // 其他通用參數
      latestTs: null,
      updateInterval: null,
      isGettingChatMsg: false,
      SCMessages: [],
      isAtBottom: true,
      selectedSCMessage: null,
      MsgConnectionFailed: false,
      newMessageLength: 0,
      isHandleScrollDetecting: true,
      fetchMoreMessagesFromApi: true,
      updateMessageInterval: UPDATE_MESSAGE_BY_API_INTERVAL,
    };
  },
  computed: {
    vodStartTs() {
      return this.streamingInfo?.replayInfo?.chatRoomBeginTime || 0;
    },
    selectedMessage() {
      return this.selectedSCIndex !== null ? this.SCMessages[this.selectedSCIndex] : null;
    },
    myUid() {
      return this.$store.state.userId || '';
    },
  },
  mounted() {
    // 如果是回放 不執行直播聊天室流程
    if (this.streamingInfo.type === 'replay') {
      this.currentLimitTs = this.vodStartTs;
      this.handleSeek();
      if (!this.updateVODMessages) {
        this.updateVODMessages = setInterval(() => {
          this.updateChatMsg();
        }, this.updateVODMessageInterval);
      }
      return;
    }
    this.getChatMsg(true);
    this.getSCMessages();
    this.startChatUpdates();
  },
  setup(props) {
    const isReplay = props.streamingInfo.type === 'replay';
    // 根據是否為回放模式決定 Socket 是否開啟
    const { isConnected, messageHistory, popChatMessages, refreshSocket } = useChatSocket(props.cid, { enabled: !isReplay });

    const afterLoginTrigger = inject('afterLoginTrigger');

    watch(afterLoginTrigger, (newVal) => {
      if (newVal > 0 && !isReplay) {
        refreshSocket();
      }
    });

    return {
      messageHistory,
      popChatMessages,
      isConnected,
    };
  },
  beforeUnmount() {
    this.stopChatUpdates();
    if (this.updateVODTimer) {
      clearInterval(this.updateVODTimer);
      this.updateVODTimer = null;
    }
    if (this.updateVODMessages) {
      clearInterval(this.updateVODMessages);
      this.updateVODMessages = null;
    }
    this.isGettingChatMsg = false;
  },
  watch: {
    isConnected(newVal) {
      if (this.streamingInfo.type === 'replay') {
        return;
      }
      // if not connected, set updateMessageInterval to UPDATE_MESSAGE_BY_API_INTERVAL
      // will reset to UPDATE_MESSAGE_INTERVAL in "getChatMsg" method
      if (!newVal) {
        this.updateMessageInterval = UPDATE_MESSAGE_BY_API_INTERVAL;
        this.fetchMoreMessagesFromApi = true;
        this.resetChatUpdates();
      }
    },
  },
  methods: {
    async getChatMsg(isInitial = false) {
      if (this.isGettingChatMsg) {
        return;
      }
      this.isGettingChatMsg = true;
      this.isHandleScrollDetecting = false;

      try {
        const cid = this.cid;
        let messages = [];
        if (isInitial) {
          const response = await streamingGetChat(cid, null);
          const responseData = response.data.data;
          messages = responseData.msg;
          this.MsgConnectionFailed = false;

          if (responseData.count === 0) {
            this.updateSCMessages();
            this.startFetchMsgFromWs();
            return;
          }

          if (!responseData.next) {
            this.startFetchMsgFromWs();
          }
        } else {
          const historyMessagesLength = this.messageHistory.length;
          const firstHistoryMessage = this.messageHistory[0];

          if (!this.isConnected || this.fetchMoreMessagesFromApi) {
            const response = await streamingGetChat(cid, this.latestTs);
            const responseData = response.data.data;
            messages = responseData.msg;
            this.MsgConnectionFailed = false;

            // WS 連線後需確認是否有未追回的訊息, 如果有, 則繼續從 Chat API 取得, 直到沒有未追回的訊息
            if (!messages.length || !responseData.next || (firstHistoryMessage && firstHistoryMessage.ts < messages[messages.length - 1].ts)) {
              this.startFetchMsgFromWs();
            }
          } else {
            messages = this.popChatMessages(Math.min(historyMessagesLength, MAX_POP_CHAT_MESSAGES));
          }

          if (messages.length === 0) {
            this.updateSCMessages();
            return;
          }
        }

        // General message emoji conversion, filter message by ts
        const processedMessages = messages
          .filter((message) => message.ts > this.latestTs)
          .map((message) => {
            return {
              ...message,
              msg: this.replaceEmojiWithImage(message.msg || ''),
            };
          });

        this.latestTs = messages[messages.length - 1].ts;

        this.chatMessages = this.processMessages(this.chatMessages, processedMessages);

        if (isInitial) {
          this.SCMessages = await this.getSCMessages();
        } else {
          this.updateSCMessages(processedMessages);
        }

        // Scroll to the bottom on first into
        if (isInitial || this.isAtBottom) {
          this.$nextTick(() => {
            this.scrollToBottom();
          });
        }
      } catch (error) {
        console.error('Error fetching chat messages:', error);
        this.MsgConnectionFailed = true;
      } finally {
        this.isGettingChatMsg = false;
        this.isHandleScrollDetecting = true;
      }
    },
    async getSCMessages() {
      try {
        const cid = this.cid;
        const response = await streamingGetSCMsg(cid);
        const SCMessages = response.data.data || [];

        return SCMessages.map((message) => ({
          ...message,
          msg: this.replaceEmojiWithImage(message.msg || ''),
        }));
      } catch (error) {
        console.error('Error fetching SC messages:', error);
        return [];
      }
    },
    onVideoSeeked(newTime) {
      if (this.streamingInfo.type !== 'replay') {
        return;
      }
      this.isGettingChatMsg = true;
      this.currentLimitTs = this.vodStartTs + newTime;
      this.isVideoSeeking = false;
      this.handleSeek();
    },
    onVideoSeeking() {
      this.isVideoSeeking = true;
      this.loading = true;
    },
    onVideoPaused() {
      this.isPlayerPlayed = false;
      if (this.updateVODTimer) {
        clearInterval(this.updateVODTimer);
        this.updateVODTimer = null;
      }
    },
    onVideoPlayed(newTime) {
      this.isPlayerPlayed = true;
      this.currentLimitTs = this.vodStartTs + newTime;

      if (!this.updateVODTimer) {
        this.updateVODTimer = setInterval(() => {
          this.updateVODInterval();
        }, this.updateVODMessageInterval);
      }
    },
    handleSeek() {
      this.canFetchNext = true; // 重啟預載開關
      this.loading = true;

      this.chatMessages = [];
      this.SCMessages = [];
      this.fullMessages = [];
      this.lastProcessedIndex = 0;
      this.newMessageLength = 0;

      // 延遲 0.5 秒後請求api 避免快速的連續輸入
      clearTimeout(this.seekDebounceTimer);
      this.seekDebounceTimer = setTimeout(() => {
        this.handleSeekGetChat();
      }, 500);
    },
    async handleSeekGetChat() {
      const targetTs = this.currentLimitTs * 0.001;
      try {
        const cid = this.cid;

        // 會抓取過去 20 秒的聊天室訊息
        const startTime = Math.max(this.vodStartTs, this.currentLimitTs - 20000);
        const response = await streamingGetChat(cid, startTime);

        // 利用時間段檢查並捨棄過時的 API 回傳資料 防止快速切換時間軸造成的聊天室資訊錯誤 (容許值 1 秒)
        const currentTs = this.currentLimitTs * 0.001;
        if (Math.abs(currentTs - targetTs) > 1) {
          return;
        }

        const responseData = response.data.data;
        this.fullMessages = responseData.msg || [];
        this.lastProcessedIndex = 0;

        if (this.fullMessages.length === 0) {
          this.loading = false;
        }
      } catch (error) {
        console.error('Seek error:', error);
        this.loading = false;
      } finally {
        this.isGettingChatMsg = false;
      }
    },
    updateVODInterval() {
      this.currentLimitTs += this.updateVODMessageInterval; // 增加時間視窗
    },
    updateChatMsg() {
      if (this.isGettingChatMsg) return;

      if (this.lastProcessedIndex > MAX_FULL_MESSAGES + 100) {
        // 每超過 100 條就執行刪除
        const removeCount = this.lastProcessedIndex - MAX_FULL_MESSAGES;
        this.fullMessages.splice(0, removeCount);
        this.lastProcessedIndex -= removeCount;
      }

      const newMessages = [];
      const remainingCount = this.fullMessages.length - this.lastProcessedIndex;
      if (this.canFetchNext && remainingCount < 20) {
        this.fetchNextSegment();
      }

      // 使用 while 迴圈和索引，只處理尚未處理的訊息
      let count = 0;
      while (this.lastProcessedIndex < this.fullMessages.length && count < MAX_POP_CHAT_MESSAGES) {
        const message = this.fullMessages[this.lastProcessedIndex];

        // 檢查訊息時間是否在當前時間視窗內
        if (message.ts <= this.currentLimitTs * 0.001) {
          // 進行必要的訊息處理（轉換表情符號）
          newMessages.push({
            ...message,
            msg: this.replaceEmojiWithImage(message.msg || ''),
          });
          // 移動索引到下一條
          this.lastProcessedIndex++;
          count++;
        } else {
          // 訊息時間大於 currentLimitTs，表示這個時間點之後的訊息還沒到顯示時機
          // 如果正在讀取且已經確定時間軸 關閉讀取
          if (this.loading && !this.isVideoSeeking) {
            this.scrollToBottom(false);
            this.loading = false;
          }
          break;
        }
      }

      this.chatMessages = this.processMessages(this.chatMessages, newMessages);
      this.updateSCMessages(newMessages);
      if (newMessages.length > 0 && this.isAtBottom && !this.loading) {
        this.$nextTick(() => this.scrollToBottom());
      }
    },
    async fetchNextSegment() {
      if (this.isGettingChatMsg) return;
      const timestampAtRequest = this.currentLimitTs;
      this.isGettingChatMsg = true;

      try {
        const cid = this.cid;
        const lastTsInCache = this.fullMessages.length > 0 ? this.fullMessages[this.fullMessages.length - 1].ts * 1000 : this.currentLimitTs;

        const response = await streamingGetChat(cid, lastTsInCache);
        const responseData = response.data.data;
        const newMsgs = responseData.msg || [];

        // 如果在請求之間再次請求 拋棄掉舊請求
        if (Math.abs(this.currentLimitTs - timestampAtRequest) > 5000) {
          return;
        }

        // 如果Api完全沒拿到訊息就關閉預載，避免迴圈重打
        if (responseData.count === 0 || newMsgs.length === 0) {
          if (!responseData.next) {
            this.loading = false;
            this.canFetchNext = false;
          }
          return;
        }

        this.fullMessages.push(...newMsgs);
      } catch (e) {
        console.error('Fetch next segment failed', e);
      } finally {
        this.isGettingChatMsg = false;
      }
    },
    processMessages(oldMessages, newMessages) {
      const safeOldMessages = Array.isArray(oldMessages) ? oldMessages : [];
      const safeNewMessages = Array.isArray(newMessages) ? newMessages : [];

      // 如果在底補訊息時, 已經超過最大訊息數, 則刪除最舊的訊息
      if (this.isAtBottom) {
        this.newMessageLength = 0;
      } else {
        this.newMessageLength += safeNewMessages.length;
      }
      let updatedMessages = [...safeOldMessages, ...safeNewMessages];
      // 對準備回傳的陣列做裁切
      if (updatedMessages.length > MAX_CHAT_MESSAGES) {
        updatedMessages = updatedMessages.slice(-MAX_CHAT_MESSAGES);
      }

      return updatedMessages;
    },
    updateSCMessages(newMessages = []) {
      let currentTime;
      if (this.streamingInfo.type == 'replay') {
        // 回放模式參照時間是影片當時撥放的時間
        currentTime = this.currentLimitTs;
      } else {
        // 直播模式參照時間是當下時間
        currentTime = Date.now();
      }
      const safeNewMessages = Array.isArray(newMessages) ? newMessages : [];
      const scMessagesToAdd = safeNewMessages.filter((message) => {
        const isSC = message.sc && message.sc.trim() !== '';
        if (!isSC) return false;
        const isNotExpired = !message.expiredTime || message.expiredTime > currentTime;
        return isNotExpired;
      });
      this.SCMessages = this.SCMessages.filter((message) => !message.expiredTime || message.expiredTime > currentTime);
      this.SCMessages.unshift(...scMessagesToAdd.reverse());
    },
    replaceEmojiWithImage(content) {
      if (typeof content !== 'string') {
        return [];
      }

      const emojiRegex = /<\[emoji="([^"]+)"\sindex=(\d+)\/emoji]>/g;
      const result = [];
      let lastIndex = 0;

      const emojiMatches = [...content.matchAll(emojiRegex)];
      const isSingleSticker = emojiMatches.length === 1 && content.trim() === emojiMatches[0][0];

      content.replace(emojiRegex, (fullMatch, emojiCode, index, offset) => {
        if (offset > lastIndex) {
          result.push({ type: 'text', content: content.slice(lastIndex, offset) });
        }

        result.push({
          type: 'emoji',
          src: `${this.$cloudFront}/Image/Public/chat_stickers/${emojiCode}/${index}.png`,
          alt: emojiCode,
          isSingleSticker,
        });

        lastIndex = offset + fullMatch.length;
      });

      if (lastIndex < content.length) {
        result.push({ type: 'text', content: content.slice(lastIndex) });
      }

      return result;
    },
    startChatUpdates() {
      if (!this.updateInterval) {
        this.updateInterval = setInterval(() => {
          this.getChatMsg(false);
        }, this.updateMessageInterval);
      }
    },
    // stopChatUpdates for Unmounted
    stopChatUpdates() {
      if (this.updateInterval) {
        clearInterval(this.updateInterval);
        this.updateInterval = null;
      }
    },
    resetChatUpdates() {
      this.stopChatUpdates();
      this.getChatMsg(false);
      this.startChatUpdates();
    },
    startFetchMsgFromWs() {
      if (this.isConnected) {
        this.fetchMoreMessagesFromApi = false;
        this.updateMessageInterval = UPDATE_MESSAGE_INTERVAL;
        this.resetChatUpdates();
      }
    },
    handleScroll() {
      if (!this.isHandleScrollDetecting) {
        return;
      }

      const chatMessages = this.$refs.chatMessages;

      // might not exist when the page is unmounted
      if (chatMessages) {
        const isBottom = Math.abs(chatMessages.scrollHeight - chatMessages.scrollTop - chatMessages.clientHeight) < 300;
        this.isAtBottom = isBottom;

        if (this.isAtBottom) {
          this.removeExtraMessages();
          this.newMessageLength = 0;
        }
      }
    },
    removeExtraMessages() {
      if (this.chatMessages.length > MAX_CHAT_MESSAGES) {
        this.chatMessages = this.chatMessages.slice(-MAX_CHAT_MESSAGES);
      }
    },
    scrollToBottom(isSmooth = true) {
      this.isAtBottom = true;
      const chatMessages = this.$refs.chatMessages;

      if (chatMessages) {
        chatMessages.scrollTo({
          top: chatMessages.scrollHeight,
          behavior: isSmooth ? 'smooth' : 'auto',
        });
        this.removeExtraMessages();
        this.newMessageLength = 0;
      }
    },
    selectSCMessage(SCMessage, event) {
      event.stopPropagation();
      this.selectedSCMessage = SCMessage;
    },
    closeSCDetail() {
      this.selectedSCMessage = null;
    },
    getImageUrl(uid) {
      const path = process.env.VUE_APP_USER_AVATAR_URL;
      return `${path}${uid}.png`;
    },
    hideImage(event) {
      event.target.src = 'https://d2uz35uzla1hiz.cloudfront.net/UserIcon/ch.png';
    },
  },
});
</script>
